import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';

import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';

const REOPEN_TRANSITION = 'reopen';
const REFULFILL_TRANSITION = 'refulfill';

class RollbackOrderPage extends Component {
  constructor(props) {
    super(props);

    const parsedOrderId = parseInt(this.props.match.params.orderId, 10);

    this.state = {
      fboId: props.fboId,
      id: parsedOrderId,
      usingNetwork: true,
      revertTransition: REOPEN_TRANSITION,
    };

    this.handleRevert = this.handleRevert.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  getRevertedStatusDisplayName(status) {
    if (status === 'closed') return 'Fulfilled';
    return 'Todo';
  }

  setRevertTransition(status) {
    let revertTransition = REOPEN_TRANSITION;

    if (status === 'closed') {
      revertTransition = REFULFILL_TRANSITION;
    }

    return revertTransition;
  }

  fetchData() {
    this.setState({ usingNetwork: true });
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }, true).then((response) => {
      const order = response.order;



      this.setState({
        id: order.id,
        order,
        revertTransition: this.setRevertTransition(order.status),
        usingNetwork: false,
      });
    });
  }

  async handleRevert() {
    try {
      this.setState({ usingNetwork: true });

      await this.postData();

      this.setState({ usingNetwork: false });

      const { history } = this.props;
      history.push({ pathname: `/orders/${this.state.id}` });
    } catch (error) {
      this.notificationSystem.addNotification({
        message: `Unable to start Order ${error.message}`,
        level: 'error',
        position: 'bc',
      });
    }
  }

  postData() {
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}/transition/${this.state.revertTransition}`;

    return Api.get(endPoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then(response => response.order);
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  renderRevertForm() {
    const disableButton = this.state.usingNetwork || !this.state.order;
    const revertedStatusDisplayName = this.state.order ? this.getRevertedStatusDisplayName(this.state.order.status) : '';

    return (
      <main className="page-content">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <div className="normal-page-header">
          <h1 className="left">Rollback {revertedStatusDisplayName} Status</h1>
          <div className="clear" />
        </div>
        <div className="page-content-items">
          <section className="page-content-item">
            Are you sure you want to revert the order status back to &quot;{revertedStatusDisplayName}&quot;
          </section>
          <button
            type="button"
            className="btn btn-medium btn-primary"
            onClick={this.handleRevert}
            disabled={disableButton}
          >
            Rollback Status
          </button>
          <button
            type="button"
            className="btn btn-medium btn-alternative-options"
            onClick={this.goBack}
            disabled={this.state.usingNetwork}
          >
            Cancel
          </button>
        </div>
      </main>
    );
  }

  render() {
    return (
      <div className="app">
        { this.renderRevertForm() }
      </div>
    );
  }
}

RollbackOrderPage.propTypes = {
  history: PropTypes.shape({}).isRequired,
  fboId: PropTypes.number.isRequired,
};

RollbackOrderPage.stateTypes = {
  fboId: PropTypes.number.isRequired,
};
export default RollbackOrderPage;




// WEBPACK FOOTER //
// ./src/Containers/Orders/RollbackOrderPage.js